import { useMemo } from 'react';

import { useReportingTimezone } from '@/app/providers/config';
import { useLocale } from '@/i18n';
import type { Formatters } from '@/i18n/format';
import { createFormatters } from '@/i18n/format';

/**
 * The formatters for the active language in the installation's reporting timezone.
 *
 * Memoized on the pair, because `Intl.DateTimeFormat` is expensive to build and a table renders a
 * date per row. The timezone comes from the configuration provider and from nowhere else: a date
 * rendered in the browser's own zone would be the wrong time for the building, and two terminals in
 * the same room would disagree about when somebody walked in.
 */
export function useFormatters(): Formatters {
  const { locale } = useLocale();
  const timeZone = useReportingTimezone();
  return useMemo(() => createFormatters(locale, timeZone), [locale, timeZone]);
}
